










































import axios from 'axios'
import 'vue-tel-input/dist/vue-tel-input.css'
import {VueTelInput} from 'vue-tel-input'

export default

	components: { VueTelInput }

	props:
		block: Object

	data: ->
		form:
			phone: ''
		loading: false
		successMsg: ''
		errorMsg: ''

	computed:
		title: -> @block?.title
		formNote: -> @block?.formNote

		klaviyoListId: -> @block?.formId
		klaviyoEndpoint: -> "/.netlify/functions/klaviyo-submit"

		phoneNumber: -> @form.phone.split(' ').join ''

		postData: ->
			listId: @klaviyoListId
			phone: @phoneNumber

	methods:
		onSubmit: ->
			try
				@successMsg = ""
				@errorMsg = ""
				@loading=true

				response = await axios.post @klaviyoEndpoint, @postData


				@loading=false

				# Handle errors in response
				if response?.data?.errors?.length
					@errorMsg = response.data.errors
				else
					@successMsg = "Successful Signup"

			catch error
				@errorMsg = error
				@success_message = ""
				@loading=false


